module.exports = __webpack_public_path__ + "static/media/bCheckbox.62fb0d79.svg";